module.exports = __webpack_public_path__ + "img/vac.46843104.svg";